@import '~less/global-variables';

.piwik {
  width: 100%;
  height: 220px;
  border: 2px solid @gray-lighter;
  border-radius: @border-radius-large;
  margin: @padding-small-horizontal 0;
}
